const dev = process.env.NODE_ENV !== "production";
export const server = dev
  ? process.env.WPGRAPHQL_URL
  : `https://admin.smeetondixon.com/graphql`;
